
/**
 * 플랫폼 지원
 */
export type CourseDraftLocalizedSectionsItemLecturesItemPlatformSupport = typeof CourseDraftLocalizedSectionsItemLecturesItemPlatformSupport[keyof typeof CourseDraftLocalizedSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftLocalizedSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
